/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  RequestCancelInboundPlansRequest,
  RequestCreateDeliveryOptionsRequest,
  RequestCreateInboundPlansRequest,
  RequestGetListingsItemsRequest,
  RequestLWAStartAuthRequest,
  RequestRegisterTrackingDetailRequest,
  RequestUpsertListingsItemsRequest,
  ResponseCreateInboundPlanResponse,
  ResponseListingsItemsResult,
} from '../models/index';
import {
    RequestCancelInboundPlansRequestFromJSON,
    RequestCancelInboundPlansRequestToJSON,
    RequestCreateDeliveryOptionsRequestFromJSON,
    RequestCreateDeliveryOptionsRequestToJSON,
    RequestCreateInboundPlansRequestFromJSON,
    RequestCreateInboundPlansRequestToJSON,
    RequestGetListingsItemsRequestFromJSON,
    RequestGetListingsItemsRequestToJSON,
    RequestLWAStartAuthRequestFromJSON,
    RequestLWAStartAuthRequestToJSON,
    RequestRegisterTrackingDetailRequestFromJSON,
    RequestRegisterTrackingDetailRequestToJSON,
    RequestUpsertListingsItemsRequestFromJSON,
    RequestUpsertListingsItemsRequestToJSON,
    ResponseCreateInboundPlanResponseFromJSON,
    ResponseCreateInboundPlanResponseToJSON,
    ResponseListingsItemsResultFromJSON,
    ResponseListingsItemsResultToJSON,
} from '../models/index';

export interface AmazonCallbackGetRequest {
    code: string;
    state: string;
    sellingPartnerId: string;
    env?: string;
}

export interface AmazonCancelInboundPlansPostRequest {
    req: RequestCancelInboundPlansRequest;
}

export interface AmazonCreateDeliveryOptionsPostRequest {
    req: RequestCreateDeliveryOptionsRequest;
}

export interface AmazonDownloadLabelsPlanIdGroupNumGetRequest {
    planId: number;
    groupNum: number;
    pageType?: string;
}

export interface AmazonInboundPlansPostRequest {
    req: RequestCreateInboundPlansRequest;
}

export interface AmazonListingsItemsPostRequest {
    req: RequestGetListingsItemsRequest;
}

export interface AmazonLwaStartPostRequest {
    req: RequestLWAStartAuthRequest;
}

export interface AmazonRegisterTrackingDetailPostRequest {
    req: RequestRegisterTrackingDetailRequest;
}

export interface AmazonUpsertListingsItemsPostRequest {
    req: RequestUpsertListingsItemsRequest;
}

/**
 * 
 */
export class AmazonApi extends runtime.BaseAPI {

    /**
     * Amazonから返るcode/stateを受け取り、refresh_tokenを保存
     * LWAコールバック受信
     */
    async amazonCallbackGetRaw(requestParameters: AmazonCallbackGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling amazonCallbackGet().'
            );
        }

        if (requestParameters['state'] == null) {
            throw new runtime.RequiredError(
                'state',
                'Required parameter "state" was null or undefined when calling amazonCallbackGet().'
            );
        }

        if (requestParameters['sellingPartnerId'] == null) {
            throw new runtime.RequiredError(
                'sellingPartnerId',
                'Required parameter "sellingPartnerId" was null or undefined when calling amazonCallbackGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        if (requestParameters['sellingPartnerId'] != null) {
            queryParameters['selling_partner_id'] = requestParameters['sellingPartnerId'];
        }

        if (requestParameters['env'] != null) {
            queryParameters['env'] = requestParameters['env'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/amazon/callback`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Amazonから返るcode/stateを受け取り、refresh_tokenを保存
     * LWAコールバック受信
     */
    async amazonCallbackGet(requestParameters: AmazonCallbackGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.amazonCallbackGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * FBA InboundPlan をキャンセル
     * FBA InboundPlan をキャンセル
     */
    async amazonCancelInboundPlansPostRaw(requestParameters: AmazonCancelInboundPlansPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling amazonCancelInboundPlansPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/amazon/cancelInboundPlans`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestCancelInboundPlansRequestToJSON(requestParameters['req']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * FBA InboundPlan をキャンセル
     * FBA InboundPlan をキャンセル
     */
    async amazonCancelInboundPlansPost(requestParameters: AmazonCancelInboundPlansPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.amazonCancelInboundPlansPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * FBA 配送オプション を作成
     * FBA 配送オプション を作成
     */
    async amazonCreateDeliveryOptionsPostRaw(requestParameters: AmazonCreateDeliveryOptionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling amazonCreateDeliveryOptionsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/amazon/createDeliveryOptions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestCreateDeliveryOptionsRequestToJSON(requestParameters['req']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * FBA 配送オプション を作成
     * FBA 配送オプション を作成
     */
    async amazonCreateDeliveryOptionsPost(requestParameters: AmazonCreateDeliveryOptionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.amazonCreateDeliveryOptionsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 配送ラベルダウンロード
     * 配送ラベルダウンロード
     */
    async amazonDownloadLabelsPlanIdGroupNumGetRaw(requestParameters: AmazonDownloadLabelsPlanIdGroupNumGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: string; }>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling amazonDownloadLabelsPlanIdGroupNumGet().'
            );
        }

        if (requestParameters['groupNum'] == null) {
            throw new runtime.RequiredError(
                'groupNum',
                'Required parameter "groupNum" was null or undefined when calling amazonDownloadLabelsPlanIdGroupNumGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageType'] != null) {
            queryParameters['pageType'] = requestParameters['pageType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/amazon/downloadLabels/{planId}/{groupNum}`.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId']))).replace(`{${"groupNum"}}`, encodeURIComponent(String(requestParameters['groupNum']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 配送ラベルダウンロード
     * 配送ラベルダウンロード
     */
    async amazonDownloadLabelsPlanIdGroupNumGet(requestParameters: AmazonDownloadLabelsPlanIdGroupNumGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: string; }> {
        const response = await this.amazonDownloadLabelsPlanIdGroupNumGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * フロントからの情報でAmazonにPlanを作成し、inboundPlanIdを返す
     * FBA InboundPlan を作成
     */
    async amazonInboundPlansPostRaw(requestParameters: AmazonInboundPlansPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseCreateInboundPlanResponse>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling amazonInboundPlansPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/amazon/inboundPlans`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestCreateInboundPlansRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseCreateInboundPlanResponseFromJSON(jsonValue));
    }

    /**
     * フロントからの情報でAmazonにPlanを作成し、inboundPlanIdを返す
     * FBA InboundPlan を作成
     */
    async amazonInboundPlansPost(requestParameters: AmazonInboundPlansPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseCreateInboundPlanResponse> {
        const response = await this.amazonInboundPlansPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * セラーIDに紐づく商品をを返す
     * FBA 商品情報取得
     */
    async amazonListingsItemsPostRaw(requestParameters: AmazonListingsItemsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListingsItemsResult>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling amazonListingsItemsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/amazon/listingsItems`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestGetListingsItemsRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListingsItemsResultFromJSON(jsonValue));
    }

    /**
     * セラーIDに紐づく商品をを返す
     * FBA 商品情報取得
     */
    async amazonListingsItemsPost(requestParameters: AmazonListingsItemsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListingsItemsResult> {
        const response = await this.amazonListingsItemsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Amazon連携のための認可URLを発行（state生成・保存込）
     * LWA認可開始URLを取得
     */
    async amazonLwaStartPostRaw(requestParameters: AmazonLwaStartPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: string; }>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling amazonLwaStartPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/amazon/lwa/start`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestLWAStartAuthRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Amazon連携のための認可URLを発行（state生成・保存込）
     * LWA認可開始URLを取得
     */
    async amazonLwaStartPost(requestParameters: AmazonLwaStartPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: string; }> {
        const response = await this.amazonLwaStartPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * FBA 追跡番号入力して発送
     * FBA 追跡番号入力して発送
     */
    async amazonRegisterTrackingDetailPostRaw(requestParameters: AmazonRegisterTrackingDetailPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling amazonRegisterTrackingDetailPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/amazon/registerTrackingDetail`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestRegisterTrackingDetailRequestToJSON(requestParameters['req']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * FBA 追跡番号入力して発送
     * FBA 追跡番号入力して発送
     */
    async amazonRegisterTrackingDetailPost(requestParameters: AmazonRegisterTrackingDetailPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.amazonRegisterTrackingDetailPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * セラセンの商品情報をDBに同期
     * FBA 商品情報更新
     */
    async amazonUpsertListingsItemsPostRaw(requestParameters: AmazonUpsertListingsItemsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling amazonUpsertListingsItemsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/amazon/upsertListingsItems`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestUpsertListingsItemsRequestToJSON(requestParameters['req']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * セラセンの商品情報をDBに同期
     * FBA 商品情報更新
     */
    async amazonUpsertListingsItemsPost(requestParameters: AmazonUpsertListingsItemsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.amazonUpsertListingsItemsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
